<button class="close-button" (click)="closeDialog(false)">
  <mat-icon svgIcon="close-icon"></mat-icon>
</button>
